var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteItemIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5688 2.71484H0.283203V4.42912C0.91438 4.42912 1.42605 4.94079 1.42605 5.57196V7.28623C1.42605 8.21618 1.42605 8.68115 1.52827 9.06264C1.80566 10.0979 2.61432 10.9066 3.64962 11.184C4.03111 11.2862 4.49608 11.2862 5.42602 11.2862C6.35596 11.2862 6.82093 11.2862 7.20242 11.184C8.23772 10.9066 9.04637 10.0979 9.32377 9.06264C9.42599 8.68115 9.42599 8.21618 9.42599 7.28623V5.57196C9.42599 4.94079 9.93766 4.42912 10.5688 4.42912V2.71484ZM4.24613 5.57157C4.24613 5.4335 4.1342 5.32157 3.99613 5.32157C3.85806 5.32157 3.74613 5.4335 3.74613 5.57157V8.42869C3.74613 8.56676 3.85806 8.67869 3.99613 8.67869C4.1342 8.67869 4.24613 8.56676 4.24613 8.42869V5.57157ZM7.10325 5.57157C7.10325 5.4335 6.99132 5.32157 6.85325 5.32157C6.71518 5.32157 6.60325 5.4335 6.60325 5.57157V8.42869C6.60325 8.56676 6.71518 8.67869 6.85325 8.67869C6.99132 8.67869 7.10325 8.56676 7.10325 8.42869V5.57157Z",
    fill: "#FD1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.43495 1.38118C4.49355 1.27182 4.62269 1.17519 4.80232 1.10627C4.98195 1.03736 5.20205 1 5.42847 1C5.65489 1 5.87498 1.03736 6.05462 1.10627C6.23425 1.17519 6.36338 1.27182 6.42198 1.38118",
    stroke: "#FD1C1C",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteItemIcon);
export default __webpack_public_path__ + "static/media/delete-item-icon.d08f641ac5963ab26e089b39ef0c9b02.svg";
export { ForwardRef as ReactComponent };